import { useState, useEffect } from 'react';
import { abTestingManager } from '../utils/abTesting';

export function useABTest(testId: string) {
  const [variantId, setVariantId] = useState<string | null>(null);
  const [config, setConfig] = useState<Record<string, any> | null>(null);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const assignedVariant = abTestingManager.assignVariant(testId);
    setVariantId(assignedVariant);
    setIsActive(assignedVariant !== null);

    if (assignedVariant) {
      const variantConfig = abTestingManager.getVariantConfig(testId, assignedVariant);
      setConfig(variantConfig);
    }
  }, [testId]);

  const trackConversion = (converted: boolean = true, metadata?: Record<string, any>) => {
    abTestingManager.trackConversion(testId, converted, metadata);
  };

  const trackImpression = () => {
    abTestingManager.trackConversion(testId, false);
  };

  return {
    variantId,
    config,
    trackConversion,
    trackImpression,
    isActive
  };
}
